import { action, payload } from 'ts-action';

import { DataSchemeProduct } from '../location';

export const COLLECTION = '[COLLECTION]';

export const GET_COLLECTION = `${COLLECTION} GET_COLLECTION`;
export const SET_COLLECTION = `${COLLECTION} SET_COLLECTION`;
export const CLEAR_COLLECTION = `${COLLECTION} CLEAR_COLLECTION`;
export const UPDATE_COLLECTION = `${COLLECTION} UPDATE_COLLECTION`;
export const LOADING_PRODUCT = `${COLLECTION} LOADING_PRODUCT`;
export const SET_COLLECTION_PRODUCTS = `${COLLECTION} SET_COLLECTION_PRODUCTS`;
export const REMOVE_PRODUCT_FROM_COLLECTION = `${COLLECTION} REMOVE_PRODUCT_FROM_COLLECTION`;

export const getCollection = action(GET_COLLECTION, payload<string[]>());

export const setCollection = action(SET_COLLECTION, payload<string[]>());

export const updateCollection = action(UPDATE_COLLECTION, payload<string>());

export const loadingProduct = action(LOADING_PRODUCT, payload<boolean>());

export const setCollectionProducts = action(SET_COLLECTION_PRODUCTS, payload<DataSchemeProduct>());

export const removeProductFromCollection = action(REMOVE_PRODUCT_FROM_COLLECTION, payload<string>());

export const clearCollection = action(CLEAR_COLLECTION);
